module.exports = __webpack_public_path__ + "media/images/about__header-sm-a21879d4f99b3c15b739e603b072809e.jpg";